import { Component, Input } from '@angular/core';
import { IconName, ButtonVariant, ButtonType, AvatarSize } from '@yupma/ui-kit';
import { UserDocument } from 'server-model';
import { RouteName, RouteLinkGenerator } from 'src/app/routing-path';
import { IAMService } from 'src/app/services/services.module';

@Component({
  selector: 'app-home-topbar',
  templateUrl: './home-topbar.component.html',
  styleUrl: './home-topbar.component.scss'
})
export class HomeTopbarComponent {
 @Input() userDocument: UserDocument | null = null

  title: string = 'Home';
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  buttonTypes = ButtonType;
  avatarSizes = AvatarSize;
  routeNames = RouteName;

  settingsRoute = RouteLinkGenerator.settings('')

  constructor(
    private iamService: IAMService,
  ) { }

  ngOnInit() {
    this.init()
  }

  private async init() {
    try {
      // const uid = this.iamService.getUserId();
      const organisationId = this.iamService.getOrganisationId();
      this.settingsRoute = RouteLinkGenerator.settings(organisationId);
      // this.userDocument = await this.userDataService.getUser(uid);
    } catch (error) {
      console.log(error)
    }
  }
}
